<template>
  <svg
    viewBox="0 0 49 48"
    xmlns="http://www.w3.org/2000/svg"
    width="49"
    height="48"
  >
    <path
      d="M13.7475 8.58579C12.9664 7.80474 11.7001 7.80474 10.9191 8.58579L8.33328 11.1716L7.7475 10.5858C6.96645 9.80474 5.70012 9.80474 4.91907 10.5858C4.13802 11.3668 4.13802 12.6332 4.91907 13.4142L6.91907 15.4142C7.70012 16.1953 8.96645 16.1953 9.7475 15.4142L13.7475 11.4142C14.5285 10.6332 14.5285 9.36683 13.7475 8.58579Z"
    />
    <path
      d="M20.3333 10C19.2287 10 18.3333 10.8954 18.3333 12C18.3333 13.1046 19.2287 14 20.3333 14H42.3333C43.4379 14 44.3333 13.1046 44.3333 12C44.3333 10.8954 43.4379 10 42.3333 10H20.3333Z"
    />
    <path
      d="M20.3333 22C19.2287 22 18.3333 22.8954 18.3333 24C18.3333 25.1046 19.2287 26 20.3333 26H42.3333C43.4379 26 44.3333 25.1046 44.3333 24C44.3333 22.8954 43.4379 22 42.3333 22H20.3333Z"
    />
    <path
      d="M18.3333 36C18.3333 34.8954 19.2287 34 20.3333 34H42.3333C43.4379 34 44.3333 34.8954 44.3333 36C44.3333 37.1046 43.4379 38 42.3333 38H20.3333C19.2287 38 18.3333 37.1046 18.3333 36Z"
    />
    <path
      d="M10.9191 20.5858C11.7001 19.8047 12.9664 19.8047 13.7475 20.5858C14.5285 21.3668 14.5285 22.6332 13.7475 23.4142L9.7475 27.4142C8.96645 28.1953 7.70012 28.1953 6.91907 27.4142L4.91907 25.4142C4.13802 24.6332 4.13802 23.3668 4.91907 22.5858C5.70012 21.8047 6.96645 21.8047 7.7475 22.5858L8.33328 23.1716L10.9191 20.5858Z"
    />
    <path
      d="M13.7475 32.5858C12.9664 31.8047 11.7001 31.8047 10.9191 32.5858L8.33328 35.1716L7.7475 34.5858C6.96645 33.8047 5.70012 33.8047 4.91907 34.5858C4.13802 35.3668 4.13802 36.6332 4.91907 37.4142L6.91907 39.4142C7.70012 40.1953 8.96645 40.1953 9.7475 39.4142L13.7475 35.4142C14.5285 34.6332 14.5285 33.3668 13.7475 32.5858Z"
    />
  </svg>
</template>
